import React, { useState } from "react";
import "./index.scss";
import api from "../../services/api";
import { FaSearch } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import notify from "devextreme/ui/notify";
import ReCAPTCHA from "react-google-recaptcha";
import captchaKey from "../../tests/captchakey";

const AcompanharProtocolo = () => {
  const [state, setState] = useState("");
  const [captcha, setCaptcha] = useState({
    permission: false,
  });
  const history = useHistory();
  const municipioId = localStorage.getItem("municipioId");

  function handleReCaptchaSize() {
    let smallSize = window.matchMedia("(max-width: 900px)");
    if (smallSize.matches) {
      return "compact";
    } else {
      return "normal";
    }
  }

  function onChange(e) {
    setCaptcha({ ...captcha, permission: true });
  }

  async function handleSubmit(e) {
    e.preventDefault();
      try {
        const response = await api.get(
          `https://apisgtwebteste.trimapservicos.com.br/api/protocolos/portal/buscar_protocolo/${municipioId}/${state}`
        );
        if (response.status === 200 && response.data) {
          history.push("" + response.data.cv, { data: response.data });
        }
      } catch (err) {
        console.log(err);
        notify(
          {
            message: "Não foi possível encontrar o protocolo",
            closeOnClick: true,
            position: { at: "top center", my: "top center", offset: "0 50" },
          },
          "error",
          10000
        );
      }
  }

  return (
    <React.Fragment>
      <div className={"content-block dx-card responsive-paddings"}>
        <div className="card-content">
          <form onSubmit={(event) => handleSubmit(event)}>
            <div className="input-group">
              <input
                placeholder="Digite o código do protocolo..."
                className="card-input"
                type="text"
                onChange={({ target }) => setState(target.value)}
              />
              <button type="submit" className="button">
                <FaSearch /> Buscar protocolo
              </button>
            </div>
            <div>
              <ReCAPTCHA
                className="captcha"
                hl="pt-BR"
                sitekey={captchaKey.key}
                onChange={onChange}
                onExpired={() =>
                  setCaptcha({
                    ...captcha,
                    permission: false,
                  })
                }
                size={handleReCaptchaSize()}
              />
            </div>
          </form>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AcompanharProtocolo;
